import React, { useState, useEffect } from 'react';

export default function PedidosCompletados({ token }) {
  const [pedidos, setPedidos] = useState([]);
  const [pedidoExpandidoId, setPedidoExpandidoId] = useState(null);

  const toggleDetalle = (id) => {
    setPedidoExpandidoId(prev => (prev === id ? null : id));
  };

  useEffect(() => {
    const cargarPedidos = async () => {
      try {
        const res = await fetch('http://localhost:5000/admin/pedidos', {
          headers: { Authorization: `Bearer ${token}` }
        });
        const data = await res.json();
        const completados = data.filter(p => p.estado === 'completado');
        setPedidos(completados);
      } catch (err) {
        console.error('❌ Error al cargar pedidos completados:', err.message);
      }
    };
    if (token) cargarPedidos();
  }, [token]);

  return (
    <div className="container py-3">
      <h3 className="text-danger mb-4">📦 Pedidos Completados</h3>
      <ul className="list-group">
        {pedidos.map(pedido => (
          <li key={pedido.id} className="list-group-item">
            <div className="d-flex justify-content-between align-items-center">
              <span>
                <strong>Cliente:</strong> {pedido.cliente_id}<br />
                <strong>Fecha:</strong> {new Date(pedido.fecha).toLocaleString()}<br />
                <strong>Entrega:</strong> {pedido.modo_entrega}
              </span>
              <button
                className="btn btn-sm btn-outline-info"
                onClick={() => toggleDetalle(pedido.id)}
              >
                {pedidoExpandidoId === pedido.id ? 'Ocultar detalles' : 'Ver detalles'}
              </button>
            </div>

            {pedidoExpandidoId === pedido.id && (
              <div className="mt-3 p-3 bg-light border rounded">
                <h6>Productos:</h6>
                <ul className="list-group mb-3">
                  {(Array.isArray(pedido.productos) ? pedido.productos : []).map((p, i) => (
                    <li key={i} className="list-group-item">
                      {p.cantidad} de {p.producto}{p.corte ? ` (${p.corte})` : ''}
                    </li>
                  ))}
                </ul>

                {pedido.envio && (
                  <>
                    <h6>Datos de envío:</h6>
                    <p><strong>Nombre:</strong> {pedido.envio.nombre}</p>
                    <p><strong>Dirección:</strong> {pedido.envio.direccion}</p>
                    <p><strong>Teléfono:</strong> {pedido.envio.telefono}</p>
                  </>
                )}

                <p><strong>Fecha de entrega:</strong> {new Date(pedido.fecha_entrega).toLocaleString()}</p>
                <p><strong>Precio final:</strong> ${pedido.precio_final}</p>
              </div>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
